import {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'

import {generate} from '../../../../routes.js'

import '../Level2Menu.scss'

export default class LeftMenuEdit extends Component {
  static propTypes = {
    className: PropTypes.string,
    link: PropTypes.object.isRequired,
  }

  static defaultProps = {
    link: {
      menu: 'freelance-profile',
      parameters: {},
      search: {},
    },
    className: ''
  }

  render() {
    const link = this.props.link
    return (
      <div className={`level2-menu freelance-menu`}>
        <div className="level2-menu-title">
          <span>Édition du profil</span>
        </div>

        <ul className={`level2-menu-list`}>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex step-link align-items-center flex-nowrap"
              to={generate({name: `${link.menu}.cv`, parameters: link.parameters, search: link.search})}
            >
              Curriculum
            </Link>
          </li>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex step-link align-items-center flex-nowrap"
              to={generate({name: `${link.menu}.preferences`, parameters: link.parameters, search: link.search})}
            >
              Préférences
            </Link>
          </li>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex step-link align-items-center flex-nowrap"
              to={generate({name: `${link.menu}.pres`, parameters: link.parameters, search: link.search})}
            >
              Présentation Générale
            </Link>
          </li>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex step-link align-items-center flex-nowrap"
              to={generate({name: `${link.menu}.mission`, parameters: link.parameters, search: link.search})}
            >
              Missions
            </Link>
          </li>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex step-link align-items-center flex-nowrap"
              to={generate({name: `${link.menu}.parcours`, parameters: link.parameters, search: link.search})}>
              Formation
            </Link>
          </li>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex step-link align-items-center flex-nowrap"
              to={generate({name: `${link.menu}.extras`, parameters: link.parameters, search: link.search})}
            >
              Langues
            </Link>
          </li>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex step-link align-items-center flex-nowrap"
              to={generate({name: `${link.menu}.alertes`, parameters: link.parameters, search: link.search})}
            >
              Alerte
            </Link>
          </li>
          <li className="level2-menu-list-item">
            <Link
              className="d-flex step-link align-items-center flex-nowrap"
              to={generate({name: `${link.menu}.avail`, parameters: link.parameters, search: link.search})}
            >
              Disponibilité / Public
            </Link>
          </li>
        </ul>
      </div>
    )
  }
}